import React, { useEffect } from "react";

import DatatablePage from "../../../layout/datatable-pages/investors";
import { fetchData, getInvestorsFieldsArray } from "../../../utils/helpers";
import { props } from "../../datatable/props";
import useDatatable from "../../hooks/useDatatable";

import "../../data/datatable-pages.css";
import { useSupabaseApp } from "../../../SupabaseApp";

/**
 * GrowthStage Component (Growth Stage Funding Sourcing)
 * 
 * Browse and discover growth stage funding sources and investors focused on
 * scaling companies. Users can search through 43+ investor attributes.
 * Shows investor statistics and investment track record. Requires authentication.
 * 
 * @returns {JSX.Element} Datatable page with growth stage funding sources
 */
const GrowthStage = () => {
  // Array of investor field keys to display in the datatable (43 fields for sourcing)
  const fieldKeys = [
    "name",
    "investorType",
    "description",
    "numOfFailedInvestments",
    "lossOnInvestments",
    "shutteredPortfolioCompanies",
    "numOfExit",
    "exitValue",
    "reputation",
    "location",
    "investmentStage",
    "investmentTrackRecord",
    "assets",
    "investmentRange",
    "sweetSpot",
    "investmentFocus",
    "investmentGeography",
    "numOfInvestments",
    "numOfLeadInvestments",
    "numOfFollowOnInvestments",
    "numOfCoInvestments",
    "numOfAcquisitions",
    "boardSeats",
    "numOfFunds",
    "limitedPartners",
    "coInvestors",
    "numofPartners",
    "partners",
    "numOfEmployeesObj",
    "management",
    "boardMembers",
    "founders",
    "email",
    "socialMedia",
    "website",
    "phone",
    "address",
    "entityType",
    "legalName",
    "primaryBusinessName",
    "formerlegalName",
    "founded",
    "stockSymbol",
  ];

  const fields = getInvestorsFieldsArray(fieldKeys);

  const { datatableProps } = useDatatable();

  // realm functions declaration
  const { currentUser, supabase, getUserTier } = useSupabaseApp();

  // check if user is logged in or not
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // params for functions
  const params = {
    supabase,
    ...datatableProps,
    getData: "getGrowthStageFunding",
    collection: "investors",
    title: "Growth stage funding",
    datatipText:
      "Search for funding with our founder-friendly collection of revenue-based financing, growth venture capital, and other growth stage funding sources.",
    statsArray: [
      {
        actualName: "financingSources",
        displayName: "Financing sources",
        total: "22,171",
      },
    ],
    placeholderText: "Search from growth stage funding",
    fields: fields,
    getCompanyDetailsForExpand: "getCompanyDetailsForExpand",
  };

  // fetch data on page load
  useEffect(() => {
    fetchData(params);
  }, []);

  return <DatatablePage props={props(params)} />;
};

export default GrowthStage;
